var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupPolicyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.39 0.355)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-2.39 -0.355)",
    style: {
      opacity: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.253,32.422A1.815,1.815,0,0,1,20.96,31.9l-5.317-5.3a2.035,2.035,0,0,1,.162-2.869l4.132-4.115a2.1,2.1,0,0,1,2.88-.159l5.318,5.294a2.039,2.039,0,0,1-.16,2.87l-4.132,4.114A2.277,2.277,0,0,1,22.253,32.422ZM21.522,20.3a.919.919,0,0,0-.622.282L16.768,24.7a.71.71,0,0,0-.161.949l5.317,5.295a.459.459,0,0,0,.329.121.909.909,0,0,0,.625-.282l4.132-4.115a.708.708,0,0,0,.158-.95L21.85,20.425A.456.456,0,0,0,21.522,20.3Z",
    transform: "translate(-14.16 -14.262)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.219,18.7c-.134,0-.263,0-.371-.014a5.242,5.242,0,1,1,5.59-4.9,3.541,3.541,0,0,1-.521,1.827.681.681,0,0,1-1.122-.771,2.322,2.322,0,0,0,.282-1.095,3.9,3.9,0,1,0-4.131,3.587,5.328,5.328,0,0,0,.774-.011.679.679,0,1,1,.138,1.351C18.695,18.687,18.45,18.7,18.219,18.7Z",
    transform: "translate(-12.928 -8.211)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.474,48.264a1.946,1.946,0,0,1-1.392-.649l-.713-.715a.679.679,0,0,1-.2-.43l-.034-.462L38.416,46a.682.682,0,0,1-.68-.694l.04-1.76-1.231-.3a.687.687,0,0,1-.3-.157l-1.3-1.167a.681.681,0,1,1,.915-1.008l1.168,1.051,1.6.384a.681.681,0,0,1,.522.675l-.037,1.616,1.662.007a.681.681,0,0,1,.677.631l.061.839.535.536a.874.874,0,0,0,.438.248.475.475,0,0,0,.243-.115l.005-1.542L37.2,39.68a.679.679,0,0,1,0-.961.686.686,0,0,1,.965,0l5.738,5.767a.677.677,0,0,1,.2.481L44.1,47.063a.687.687,0,0,1-.124.389,2.007,2.007,0,0,1-1.364.807C42.565,48.262,42.52,48.264,42.474,48.264Z",
    transform: "translate(-25.154 -25.264)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.817,30.743a1.213,1.213,0,0,1-.861-2.069,1.254,1.254,0,0,1,1.729,0,1.21,1.21,0,0,1-.006,1.714A1.225,1.225,0,0,1,25.817,30.743Zm0-1.358a.139.139,0,0,0-.095.038.145.145,0,1,0,.2.208.14.14,0,0,0,0-.2A.15.15,0,0,0,25.817,29.384Z",
    transform: "translate(-19.476 -19.529)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.323,37.133a.679.679,0,0,1-.482-1.16l2.314-2.3a.68.68,0,0,1,.964.961l-2.314,2.3A.683.683,0,0,1,30.323,37.133Z",
    transform: "translate(-22.301 -22.421)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupPolicyIcon);
export default __webpack_public_path__ + "static/media/group-policy-icon.e080f39a.svg";
export { ForwardRef as ReactComponent };